var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"mr-1",attrs:{"size":"sm","variant":"none","title":"Editar"},on:{"click":_vm.click}},[_c('b-icon-pencil-square')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }